<template>
  <div class="transaction-detail">
    <div class="transaction-detail__header">
      <Heading class="transaction-detail__text" :level="3">Cálculo</Heading>
      <BaseText
        class="transaction-detail__text"
        :color="NebraskaColors.textSecondary"
        size="sm"
      >
        Valores desde o início da carteira
      </BaseText>
    </div>
    <div class="transaction-detail__wrapper">
      <Row has-line>
        <template #top-left>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            Total investido
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            {{ getRowValues(detailProps.totalIncoming) }}
          </BaseText>
        </template>
      </Row>
      <Row has-line>
        <template #top-left>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            Total resgatado
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            {{ detailProps.totalNetOutgoing.formatted }}
          </BaseText>
        </template>
      </Row>
      <Row v-if="detailProps.totalIncomeTax" has-line>
        <template #top-left>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            Imposto de renda
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            {{ detailProps.totalIncomeTax.formatted }}
          </BaseText>
        </template>
      </Row>
      <Row v-if="detailProps.totalOperationTax" has-line>
        <template #top-left>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            IOF
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            {{ detailProps.totalOperationTax.formatted }}
          </BaseText>
        </template>
      </Row>
      <Row has-line>
        <template #top-left>
          <BaseText
            class="transaction-detail__bold"
            :color="NebraskaColors.textPrimary"
            size="lg"
          >
            Movimentações
          </BaseText>
        </template>
        <template #top-right>
          <BaseText
            class="transaction-detail__bold"
            :color="NebraskaColors.textPrimary"
            size="lg"
          >
            {{ getRowValues(detailProps.transactionsNetBalance) }}
          </BaseText>
        </template>
      </Row>
      <div
        v-if="detailProps.transactionsNetBalance < 0"
        class="transaction-detail__disclaimer"
        :has-line="false"
      >
        <BaseText
          :color="NebraskaColors.textPrimary"
          size="sm"
          class="transaction-detail__text"
        >
          Parabéns, você obteve lucro ao resgatar mais do que investiu na
          carteira.
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Row, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioTransactionsSummary } from '@/modules/wealth/services/investment/investment-types';
import { moneyFormat } from '@/modules/common/helpers/currency';

@Component({
  components: {
    Heading,
    Row,
    BaseText
  }
})
export default class TransactionDetail extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: true })
  readonly detailProps!: IPortfolioTransactionsSummary;

  public getRowValues(value: number) {
    return moneyFormat(value, false);
  }
}
</script>

<style lang="less" scoped>
.transaction-detail {
  width: 100%;

  &__text {
    margin-bottom: 0;
    text-align: start;
  }

  &__wrapper {
    margin-bottom: @size-spacing-x600;
  }

  &__header {
    margin-bottom: @size-spacing-x400;
  }
  &__bold {
    font-weight: bold;
  }

  &__content {
    margin: @size-spacing-x350 0;
    text-align: start;
  }

  &__disclaimer {
    margin-top: @size-spacing-x400;
    background: @background-primary;
    border-radius: @size-radius-x200;
    padding: @size-spacing-x450 @size-spacing-x500;
  }
}
</style>
